<div class="login">
    <div class="container-lg">
        <div class="my-container">
            <div class="card border-0">
                <form #loginForm="ngForm" (submit)="iniciarSesion()">
                    <div class="card-header">
                        <h3 class="page-title text-center">
                            Iniciar Sesión
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group pb-4 text-center">
                            <label for="email" class="group-title pb-1">Nombre o correo electrónico</label>
                            <input type="email" class="form-control" id="email" #email="ngModel"
                                [(ngModel)]="user.email" name="email" required aria-required="true"
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" autocomplete="email">
                        </div>
                        <div class="form-group pb-4 text-center">
                            <label for="password" class="group-title pb-1">Contraseña</label>
                            <input type="password" class="form-control" id="password" #password="ngModel"
                                [(ngModel)]="user.password" name="password" required aria-required="true"
                                autocomplete="current-password">
                        </div>
                        <div class="row">
                            <div class="col-lg-6 form-group">
                                <span for="remember-me" class="content-text">Recuérdame</span>
                                <input type="checkbox" id="remember-me" class="mx-1" #rememberMe="ngModel"
                                    [(ngModel)]="options.rememberMe" name="remember-me" required aria-required="true">
                                <div class="invalid-feedback">Example invalid feedback text</div>
                            </div>
                            <div class="col-lg-6">
                                <a class="nav-link float-right text-sky-blue p-0 info-text">
                                    Se te olvidó la contraseña
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row text-center">
                            <div class="col-lg-12 mb-4">
                                <button type="submit" name="login" id="login"
                                    class="btn btn-primary btn-lg btn-leer-mas">
                                    {{ "Iniciar" | uppercase }}
                                </button>
                            </div>
                            <div class="col-lg-12">
                                <a class="nav-link text-sky-blue p-0 info-text">
                                    Crear una cuenta
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>